import { useState } from "react";

import { strCode } from "../../consts";
import { deviceGroupsService, log, notificationService, t } from "../../services";
import { deviceGroupUtils } from "../../utils";

export const useDeleteDeviceGroup = () => {
  const [loading, setLoading] = useState(false);

  const mutationCallback = async (groupId) => {
    setLoading(true);

    try {
      await deviceGroupsService.deleteGroup(groupId);
    } catch (error) {
      log.error("deleteDeviceGroup error", error);

      notificationService.showError({
        title: t(strCode.DELETE_DEVICE_GROUP_ERROR),
        message: t(
          deviceGroupUtils.parseGroupsErrorMessage(
            error?.response?.data?.error ? error.response.data.error : error?.toString()
          )
        )
      });
    } finally {
      setLoading(false);
    }
  };

  return { mutationCallback, loading };
};
